import { render, staticRenderFns } from "./claimTaxAmount.vue?vue&type=template&id=dea2489a&scoped=true&"
import script from "./claimTaxAmount.vue?vue&type=script&lang=js&"
export * from "./claimTaxAmount.vue?vue&type=script&lang=js&"
import style0 from "./claimTaxAmount.vue?vue&type=style&index=0&id=dea2489a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea2489a",
  null
  
)

export default component.exports